define('app/views/special_discount_view',['app/setup'], function(takhfifan) {

  takhfifan.specialDiscountView = takhfifan.BaseView.extend({
    events: {
      'click a': 'bannerClick'
    },

    bannerClick: function() {
      takhfifan.eventHub.trigger('trackSpecialDiscount:click');
    }
  });
});
